<div class="cm-xyz" (click)="transformModeChanged.emit(TransformMode.Translate)">
    <div class="cm-xyz-label" [class.cm-active]="$transformMode() === TransformMode.Translate">
        <i class="far fa-arrows-up-down-left-right"></i>
    </div>
    <cm-input-container>
        <ng-container cm-inline-label> X: </ng-container>
        <ng-container cm-input>
            <cm-numeric-input [value]="$translateValueX()" (valueChange)="setTranslateValueX($event)" [decimalPlaces]="2"> </cm-numeric-input>
        </ng-container>
    </cm-input-container>
    <cm-input-container>
        <ng-container cm-inline-label> Y: </ng-container>
        <ng-container cm-input>
            <cm-numeric-input [value]="$translateValueY()" (valueChange)="setTranslateValueY($event)" [decimalPlaces]="2"> </cm-numeric-input>
        </ng-container>
    </cm-input-container>
    <cm-input-container>
        <ng-container cm-inline-label> Z: </ng-container>
        <ng-container cm-input>
            <cm-numeric-input [value]="$translateValueZ()" (valueChange)="setTranslateValueZ($event)" [decimalPlaces]="2"> </cm-numeric-input>
        </ng-container>
    </cm-input-container>
</div>
<div class="cm-xyz" (click)="transformModeChanged.emit(TransformMode.Rotate)">
    <div [class.cm-active]="$transformMode() === TransformMode.Rotate" class="cm-xyz-label">
        <i class="far fa-arrows-rotate"></i>
    </div>
    <cm-input-container>
        <ng-container cm-inline-label> X: </ng-container>
        <ng-container cm-input>
            <cm-numeric-input [value]="$rotationValueX()" (valueChange)="setRotationValueX($event)" [decimalPlaces]="2" [readonly]="$rotationReadonly()">
            </cm-numeric-input>
        </ng-container>
    </cm-input-container>
    <cm-input-container>
        <ng-container cm-inline-label> Y: </ng-container>
        <ng-container cm-input>
            <cm-numeric-input [value]="$rotationValueY()" (valueChange)="setRotationValueY($event)" [decimalPlaces]="2" [readonly]="$rotationReadonly()">
            </cm-numeric-input>
        </ng-container>
    </cm-input-container>
    <cm-input-container>
        <ng-container cm-inline-label> Z: </ng-container>
        <ng-container cm-input>
            <cm-numeric-input [value]="$rotationValueZ()" (valueChange)="setRotationValueZ($event)" [decimalPlaces]="2" [readonly]="$rotationReadonly()">
            </cm-numeric-input>
        </ng-container>
    </cm-input-container>
</div>
@if ($can().read.menu("advancedTemplateEditor")) {
    <cm-toggle [toggle]="$useMaxCoordinates()" (toggleChange)="$useMaxCoordinates.set($event)">
        <ng-container cm-text> 3DS Max / Blender coordinates </ng-container>
    </cm-toggle>
}
